/** sessionStorage — kirishdan keyin qaytish yo‘li */
export const AUTH_RETURN_PATH_KEY = 'authReturnPath';

/** Admin tezkor buyurtma muvaffaqiyatidan keyin «Mening buyurtmalarim» da banner */
export const FLASH_ORDER_OK_KEY = 'nuur_flash_order_ok';
